import React from 'react'
import { Form, Input } from 'antd'

export default ({ prevPath, maxLength = 900 }) => (
    <Form.Item name={[...prevPath, 'explanation']} label="解析">
        <Input.TextArea showCount maxLength={maxLength} autoSize={{ minRows: 3, maxRows: 5 }} />
    </Form.Item>
)
